import request from '@/utils/request'

export function bookingOrders_index(params) {
  return request({ url: '/merchant/bookingOrders/index', method: 'get', params })
}

export function bookingOrders_statistics(params) {
  return request({ url: '/merchant/bookingOrders/statistics', method: 'get', params })
}